import router from '@/router'
import axios from '@axios'

const route = 'register/supplier'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, {
      itemsPerPage, page, search, sortBy,
    }) {
      return axios.get(`${route
      }?page=${page
      }&items_per_page=${itemsPerPage
      }&sort_by=${sortBy
      }&search=${search}`)
    },

    store(context, supplier) {
      return axios.post(route, supplier)
    },

    update(context, supplier) {
      return axios.put(`${route}/${supplier.id}`, supplier)
    },

    destroy(context, supplier) {
      return axios.delete(`${route}/${supplier.id}`)
    },

    getStates() {
      return axios.get('helper/states')
    },

    getCities(context, state_id) {
      return axios.get(`helper/cities/${state_id}`)
    },

    /**
     * Retorna os pedidos de compra do fornecedor
     * @param  supplier_id id do fornecedor
     * @returns
     */
    loadPurchaseOrderPerSupplier(constext, supplier_id) {
      return axios.get(`${route}/purchase_order/${supplier_id}`)
    },

    /*
      * Retorna os produtos do fornecedor
    */
    loadSupplierProducts(constext, supplier_id) {
      return axios.get(`${route}/products/${supplier_id}`)
    },

    // donwload excel
    exportExcel(context, params) {
      return axios.post(`${route}/export_excel`, params, { responseType: 'blob' })
    },
  },
}
